import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-[#0A1F44] tracking-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              AUSTIN DRYWALL, LLC
            </h1>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-[#0A1F44] font-medium transition-colors cursor-pointer relative group"
            >
              Features
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#0A1F44] transition-all group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className="text-gray-700 hover:text-[#0A1F44] font-medium transition-colors cursor-pointer relative group"
            >
              Security
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#0A1F44] transition-all group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-[#0A1F44] font-medium transition-colors cursor-pointer relative group"
            >
              About
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#0A1F44] transition-all group-hover:w-full"></span>
            </button>
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className="px-6 py-2.5 border-2 border-[#0A1F44] text-[#0A1F44] rounded-lg font-medium hover:bg-[#0A1F44] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            Contact Us
          </button>
        </div>
      </div>
    </nav>
  );
}
